<template>
  <div>
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title" style="color#fff">
            {{ name }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list>
      <v-list-tile
        value="true"
        v-for="(item, i) in items"
        :key="i"
        :to="item.route"
         class="tile"
      >
        <v-list-tile-action>
          <v-icon>{{item.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: "Teacher",
      items: [
        { title: 'Dashboard', icon: 'dashboard', route: { name: 'teacher.dashboard' } },
        { title: 'Students', icon: 'people_outline', route: { name: 'teacher.students' } },
        { title: 'Attendance', icon: 'people_outline', route: { name: 'teacher.attendance' } },
        { title: 'Assessment', icon: 'people', route: { name: 'teacher.assessment' } },
        { title: 'My Account', icon: 'account_box', route: { name: 'settings.profile' } }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NavMenus/Teacher.vue